'use strict';

/*@ngInject*/
export function Errors(appConfig, Modal, $log) {
  'ngInject';
  return {
    // TODO: Add rollbar integration for errors that are caught
    error(alert) {
      Modal.alert.error(alert);
      $log.error(alert.error);
      throw new Error(alert.error);
    },
    warn(alert) {
      Modal.alert.warn(alert);
    },
    silent(error) {
      // No modal
      $log.error(error);
    },
    handleUncaught(exception, cause) {
      $log.error(exception, cause);
    }
  };
}

export function ExceptionHandler($injector) {
  'ngInject';

  return function(exception, cause) {
    let Errors = $injector.get('Errors');
    Errors.handleUncaught(exception, cause);
  };
}


export default angular.module('fplTruescapeComApp.Errors', [])
  .factory('Errors', Errors)
  .factory('$exceptionHandler', ExceptionHandler)
  .name;



// WEBPACK FOOTER //
// ./client/components/Errors/Errors.service.js